{
  "safetyDataSheets": "安全データシート（SDS）と製品環境安全情報シート（AIS）",
  "bodyContentParagraph1": "化学製品の安全データシート（SDS）と印刷用プレートならびに機器などの製品環境安全シート（AIS）には、各国特有の規制情報が含まれています。",
  "bodyContentParagraph2": "SDSおよびAISは、安全な使用と廃棄に関する規定を提供するために他の製品でも利用できる場合がありますが、製品が化学物質または混合物として規制の対象となることを意味するものではありません。",
  "bodyContentParagraph3": "SDSまたはAISを検索するには：",

  "bodyContentList1": "レポートカテゴリー（SDSまたはAIS）を選択します。",
  "bodyContentList2": "国／地域（言語）を選択します。注意：すべてのレポートがすべての言語で用意されているわけではありません。",
  "bodyContentList3": "<strong> <b>＜SDSを見つけるには＞</b> </strong> 適切な検索フィールドにカタログ番号（スペースおよびハイフンなし）、または製品ラベルから取得した部分的または完全な製品名を入力します。",
  "bodyContentList4": "<strong> <b>＜AISを見つけるには＞</b> </strong> 製品ラベルから取得した部分的または完全な製品名をキーワード検索フィールドに入力します。",
  "bodyContentList5": "検索ボタンをクリックします。",

  "reportCategory": "レポートカテゴリー:",
  "country": "国/地域:",
  "language": "言語:",
  "catalogNumber": "カタログ/再注文番号:",
  "productName": "商品名／キーワード:",
  "search": "検索 ",

  "inquiriesSentTo": "SDSを検索しても情報が見つからない場合は、以下の情報を確認してください。お問い合わせは<a href='mailto:us-pep@kodak.com'>us-pep@kodak.com</a>に送信願います。",

  "platesAndEquipment": "＜プレートと機器＞",
  "platesAndEquipmentContent": "コダックのプレートと機器は、通常の状態では物理的な危険や健康上のリスクをもたらさないため、SDSは必要ありません。",

  "kodakBrandPartner": "＜コダックのブランドパートナー製品＞",
  "kodakBrandPartnerContent": "お客様がお求めの情報が、コダックのブランドパートナー企業によって販売されている製品に関するものである可能性があります。この場合、SDSまたはAISについては、コダックのブランドパートナーに直接お問い合わせください。",

  "batteries": "＜バッテリー＞",
  "strandEurope": "以下のURLでStrand Europeまでお問合せください。<a href='https://www.kodakbatteries.strandeurope.com' target='_blank'>www.kodakbatteries.strandeurope.com</a>",

  "consumerAndProfessionalPhotographicProducts": "＜コンシューマーおよびプロフェッショナル向けの写真製品および文書スキャナー＞",
  "kodakAlaris": "<a href='https://www.kodakalaris.com' target='_blank'>www.kodakalaris.com</a> でKodak Alarisまでお問合せください。",

  "divestedProducts": "＜事業売却済みの製品＞",
  "devistedProductsContent": "お客様がお求めの情報は、事業売却の一部として他の会社に移譲された製品に関する情報の可能性があります。この場合、SDSまたはAISについては、その企業に直接お問い合わせください。",

  "medicalDentalAndIndustrialXrayProducts": "＜医療、歯科、および工業用X線製品＞",
  "carestreamHealth": "1-888-777-2072または<a href='https://www.carestream.com' target='_blank'>www.carestream.com</a> でCarestream Health, Inc.までお問い合わせください。",

  "laboratoryAndResearchChemicals": "＜研究所および研究用ケミカル＞",
  "fisherChemicalCompany": "1-800-766-7000または <a href='https://www.fishersci.com' target='_blank'>www.fishersci.com</a>  でFisher Chemical Companyまでお問い合せください。",

  "fibersAndPlastics": "＜ファイバーおよびプラスチック＞",
  "eastmanChemicalCompany": "423-229-2000または<a href='https://www.eastman.com' target='_blank' >www.eastman.com</a> でEastman Chemical Companyまでお問合せください。",

  "copyright": "Copyright ©2024 Eastman Kodak Company. All Rights Reserved.",

  "termsOfUse": "利用規約",
  "privacy": "プライバシー",
  "accessibility": "アクセシビリティ",
  "GridHeaders": {
    "Report Category":"レポートカテゴリー",
    "Country":"国",
    "Language":"言語",
    "Document Revision Number":"文書改訂番号",
    "CatalogNumber":"カタログ番号",
    "Document Name": "文書名"
  },
  "HeaderLinks":"https://www.kodak.com/ja",

  "FallbackMessage":"ご迷惑をおかけして申し訳ありません。現在サービスをご利用いただけません。",
  "report_Categories_dropdown": [
    {"CatogeryType":"SDS" ,"displayName": "製品SDS" },
    {"CatogeryType":"AIS" ,"displayName":"Article Information Sheet"},
    {"CatogeryType":"DGW","displayName": "Dangerous Goods (DG) Worksheet"}
  ]
}
